import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { PessoaContatoTipo, contatoTipos, outrosContatosTipos } from '../pessoa-contato-tipo';
import { PessoaContatoTipoSortPipe } from '../pipes';

@Component({
    selector: 'sgt-pessoa-contato-tipo-multiselect',
    templateUrl: './pessoa-contato-tipo-multiselect.component.html',
    styleUrls: ['./pessoa-contato-tipo-multiselect.component.less'],
    providers: [
        PessoaContatoTipoSortPipe
    ]
})
export class PessoaContatoTipoMultiselectComponent implements OnInit {
    /** Se deve listar somente os "outros contatos" */
    @Input() somenteOutrosContatos = true;
    /** Tipos dos contatos selecionados */
    @Input() tipos: number[];
    /** Ao alterar a seleção das tipos dos contatos */
    @Output() tiposChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum Tipo';
    @Input() checked = 'Tipo';
    @Input() checkedPlural = 'Tipos';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todas Selecionados';
    @Input() searchEmptyResult = 'Nenhum tipo encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    constructor(private pessoaContatoTipoSortPipe: PessoaContatoTipoSortPipe) { }

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-pessoa-contato-tipo ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria as tipos dos contatos para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        const tipos = this.pessoaContatoTipoSortPipe.transform(this.somenteOutrosContatos ? outrosContatosTipos : contatoTipos);
        tipos.forEach(tipo => {
            selects.push({
                id: tipo.id,
                name: tipo.nome,
            });
        });
        this.options = selects;
    }

    /** Ao alterar a seleção das tipos dos contatos */
    onChange() {
        this.tiposChange.emit(this.tipos);
    }
}
